// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".access-denied[data-v-e226a5fe]{text-align:center;margin-top:50px}", ""]);
// Exports
module.exports = exports;
